import PropTypes from 'prop-types';
import React, { Component } from 'react';

class OptionVariantField extends Component {
  render() {
    const { variants, formValues, input, formIndexKey } = this.props;

    const eachFormItemValue = formValues && formValues.items[formIndexKey].name;
    const optVariants = variants && variants[eachFormItemValue];

    return (
      <div>
        <select
          {...input}
          className="form-control"
          disabled={!optVariants || optVariants.length === 1}
        >
          {optVariants ? (
            optVariants.map((val, key) => {
              return (
                <option key={key} value={val}>
                  {val}
                </option>
              );
            })
          ) : (
            <option value="no variant" disabled selected="no variant">
              Variant Options
            </option>
          )}
        </select>
      </div>
    );
  }
}

OptionVariantField.propTypes = {
  variants: PropTypes.array,
};

export default OptionVariantField;
